import { useToasterState } from "../../react-components-core";
import { Toast } from "../Toast";

export default function Toaster(): JSX.Element {
    const toast = useToasterState(Toast);

    return <div id="toast-root">{toast}</div>;
}
